import {Component, Injector, OnInit} from '@angular/core';
import {EditAddressesComponent} from '../dialog/edit-addresses/edit-addresses.component';
import {BaseComponent} from '../../base.component';
import {SnackBarUtil} from '../../../util/snack.bar.util';
import {RequestType} from '../../../enums/request.type';
import {ListResponse} from '../../../network/service/list.response';
import {Config} from '../../../common/config';

@Component({
  selector: 'app-addresses',
  standalone: false,
  templateUrl: './addresses.component.html',
  styleUrl: './addresses.component.scss'
})
export class AddressesComponent extends BaseComponent implements OnInit {
  isLoadMore: boolean = true;
  userAddresses?: any[];
  userAddressesCount?: number;
  protected readonly Config = Config;

  constructor(injector: Injector) {
    super(injector);
  }

  override ngOnInit() {
    super.ngOnInit();
  }

  override loadOnline() {
    super.loadOnline();
    if (!this.isLoadMore) {
      return;
    }
    if (this.tableProperties.offset === 0) {
      this.userAddresses = [];
    }
    this.serviceApi.getUserAddresses(this.tableProperties.offset, this.tableProperties.limit, undefined, RequestType.PAGINATE, {
      Filter: {
        Values: [{
          Field: 'UserId',
          Type: 'EQ',
          Value: this.Config.userInformation.UserId
        }]
      }
    }).subscribe((res: ListResponse<any>) => {
      if (res.success) {
        if ((res.data?.length ?? 0) < this.tableProperties.limit) {
          this.isLoadMore = false;
        } else {
          this.tableProperties.offset++;
        }
        this.userAddresses = this.userAddresses!.concat(res.data);
        this.userAddressesCount = res.count;
      } else {
        this.userAddresses = [];
        this.userAddressesCount = 0;
        SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
      }
    });
  }

  onUserAddressRemoveClicked(userAddress: any) {
    this.serviceApi.deleteUserAddresses(userAddress.UserAddressId).subscribe((res: ListResponse<any>) => {
      if (res.success) {
        this.tableProperties.offset = 0;
        this.isLoadMore = true;
        this.loadOnline();
      } else {
        SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
      }
    });
  }

  openBackClicked() {
    this.location.back();
  }

  onEditAddressesClicked(userAddress: any) {
    const isMobile = window.innerWidth <= 992;
    this.matDialog.open(EditAddressesComponent, {
      width: isMobile ? '100%' : '1284px',
      height: isMobile ? 'auto' : '60%',
      panelClass: isMobile ? 'mobile-dialog-panel' : 'desktop-dialog-panel',
      data: userAddress,
    });
  }

  onCreateAddressesClicked(): void {
    const isMobile = window.innerWidth <= 992;
    this.matDialog.open(EditAddressesComponent, {
      width: isMobile ? '100%' : '1284px',
      height: isMobile ? 'auto' : '60%',
      panelClass: isMobile ? 'mobile-dialog-panel' : 'desktop-dialog-panel',
      data: {}
    });
  }
}
